"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyPartial = exports.createUtteranceElement = void 0;
const __1 = require("..");
const actionItemTypes_1 = require("../types/actionItemTypes");
const metaUtil_1 = require("./metaUtil");
const createUtteranceElement = (utterance, status) => {
    const { id, agendaItemId, speaker, startDate, endDate, dialogue, isProcessed } = utterance;
    return {
        type: __1.CustomElementType.Utterance,
        artifactId: {
            type: __1.ObjectType.Transcript,
            field: __1.ObjectField.Object,
            id,
        },
        itemStatus: status,
        isProcessed,
        containsKeyword: checkContainsKeyword(dialogue),
        children: [
            (0, metaUtil_1.getUtteranceMetaData)(id, {
                startDate,
                endDate,
                agendaItemId,
                speaker,
            }),
            (0, __1.createField)('', dialogue, false, true, {
                type: __1.ObjectType.Transcript,
                field: __1.ObjectField.Dialogue,
                id,
            }),
        ],
    };
};
exports.createUtteranceElement = createUtteranceElement;
const createEmptyPartial = () => {
    return {
        id: '',
        startDate: '',
        dialogue: '',
        isProcessed: actionItemTypes_1.BooleanString.False,
    };
};
exports.createEmptyPartial = createEmptyPartial;
const checkContainsKeyword = (dialogue) => {
    const keywordExp = /action item/gi;
    const keywordRegex = new RegExp(keywordExp);
    return !!dialogue.match(keywordRegex);
};
